var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:{ 'is-icon-mr-075': _vm.lock },attrs:{"size":"mini","type":_vm.type},on:{"click":_vm.updateEditValue}},[(_vm.lock)?_c('i',{staticClass:"far fa-lock-alt"}):_vm._e(),_vm._v(_vm._s(_vm.$t(_vm.label))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c2b3d40","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/button/nuttrema-edit-lock-button.vue
// module id = 3029
// module chunks = 0